var CommonBaseInputsView, EmailFormBaseView, SharedAjaxError, StepActionsView, SupportStepThreeActionsTemplate, SupportUtils,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

StepActionsView = require("../step_actions_view");

CommonBaseInputsView = require("../common/views/common_base_inputs_view");

SupportUtils = require("../../helpers/utils");

SharedAjaxError = require("../../../../shared/frontend/views/ajax_error_view");

SupportStepThreeActionsTemplate = require('../../../step_three_actions.html.mustache');

EmailFormBaseView = (function(superClass) {
  extend(EmailFormBaseView, superClass);

  function EmailFormBaseView() {
    return EmailFormBaseView.__super__.constructor.apply(this, arguments);
  }

  EmailFormBaseView.prototype.className = 'email-form';

  EmailFormBaseView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    return this.I18nScope = 'modules.support';
  };

  EmailFormBaseView.prototype.renderStepActions = function() {
    var stepActionsView;
    stepActionsView = new StepActionsView({
      template: SupportStepThreeActionsTemplate
    });
    stepActionsView.render();
    return this.$el.append(stepActionsView.el);
  };

  EmailFormBaseView.prototype.hideComponents = function() {
    return SupportUtils.hideFloatingBoldChat();
  };

  EmailFormBaseView.prototype.renderSuccess = function(response) {
    return window.location.href = "#ticket-success";
  };

  EmailFormBaseView.prototype.renderError = function() {
    var errorView;
    errorView = new SharedAjaxError();
    return errorView.render({
      container: $('#help-wizard')
    });
  };

  EmailFormBaseView.prototype.submitForm = function(data) {
    return createTicket(data, this.renderSuccess, this.renderError, $('.help-wizard'));
  };

  return EmailFormBaseView;

})(CommonBaseInputsView);

module.exports = EmailFormBaseView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9iYXNlX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9iYXNlX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsd0hBQUE7RUFBQTs7O0FBQUEsZUFBQSxHQUFrQixPQUFBLENBQVEsc0JBQVI7O0FBQ2xCLG9CQUFBLEdBQXVCLE9BQUEsQ0FBUSx5Q0FBUjs7QUFDdkIsWUFBQSxHQUFlLE9BQUEsQ0FBUSxxQkFBUjs7QUFDZixlQUFBLEdBQWtCLE9BQUEsQ0FBUSxtREFBUjs7QUFDbEIsK0JBQUEsR0FBa0MsT0FBQSxDQUFRLDJDQUFSOztBQUU1Qjs7Ozs7Ozs4QkFDSixTQUFBLEdBQVc7OzhCQUVYLFVBQUEsR0FBWSxTQUFBO0lBQ1Ysb0JBQW9CLENBQUEsU0FBRSxDQUFBLFVBQVUsQ0FBQyxLQUFqQyxDQUF1QyxJQUF2QyxFQUE2QyxTQUE3QztXQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7RUFGSDs7OEJBSVosaUJBQUEsR0FBbUIsU0FBQTtBQUNqQixRQUFBO0lBQUEsZUFBQSxHQUFrQixJQUFJLGVBQUosQ0FDaEI7TUFBQSxRQUFBLEVBQVUsK0JBQVY7S0FEZ0I7SUFFbEIsZUFBZSxDQUFDLE1BQWhCLENBQUE7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxlQUFlLENBQUMsRUFBNUI7RUFKaUI7OzhCQU1uQixjQUFBLEdBQWdCLFNBQUE7V0FDZCxZQUFZLENBQUMsb0JBQWIsQ0FBQTtFQURjOzs4QkFHaEIsYUFBQSxHQUFlLFNBQUMsUUFBRDtXQUNiLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBaEIsR0FBdUI7RUFEVjs7OEJBR2YsV0FBQSxHQUFhLFNBQUE7QUFDWCxRQUFBO0lBQUEsU0FBQSxHQUFZLElBQUksZUFBSixDQUFBO1dBQ1osU0FBUyxDQUFDLE1BQVYsQ0FBaUI7TUFBQyxTQUFBLEVBQVcsQ0FBQSxDQUFFLGNBQUYsQ0FBWjtLQUFqQjtFQUZXOzs4QkFJYixVQUFBLEdBQVksU0FBQyxJQUFEO1dBQ1YsWUFBQSxDQUFhLElBQWIsRUFBbUIsSUFBQyxDQUFBLGFBQXBCLEVBQW1DLElBQUMsQ0FBQSxXQUFwQyxFQUFpRCxDQUFBLENBQUUsY0FBRixDQUFqRDtFQURVOzs7O0dBdkJrQjs7QUEwQmhDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
